import type React from "react";
import { LoginPage } from "@frontend/shared/presentation/pages/LoginPage";
import { EventLandingPage } from "@/features/event-landing/presentation/pages/EventLandingPage";
import { useEventSubdomain } from "../hooks/useEventSubdomain";

export function DefaultPage(): React.JSX.Element {
  const eventSubdomain = useEventSubdomain();

  if (eventSubdomain !== null) {
    return <EventLandingPage eventIdPublicOrSlug={eventSubdomain} />;
  }

  return <LoginPage />;
}
